import { useState } from "react";

// Shared shape for the "collapsible card that can be force-expanded for PDF
// export" pattern used across the Team Personality report sections.
export default function useCollapsibleSection(
  forceExpanded?: boolean,
  defaultCollapsed = false
) {
  const [isCollapsed, setIsCollapsed] = useState(defaultCollapsed);

  const toggleIsCollapsed = () => {
    setIsCollapsed(!isCollapsed);
  };

  return { collapsed: isCollapsed && !forceExpanded, toggleIsCollapsed };
}
